import { SingleEventHandler } from '@edreamsodigeo/frontend-core';
const RequestHandler = () => {
  const singleEventHandler = SingleEventHandler();
  return {
    perform: singleEventHandler.trigger,
    onSearch: singleEventHandler.listen,
    stopOnSearch: singleEventHandler.stopListening
  };
};
export default RequestHandler;